import { render, staticRenderFns } from "./SectionRanking.vue?vue&type=template&id=07e17978&scoped=true"
import script from "./SectionRanking.vue?vue&type=script&lang=js"
export * from "./SectionRanking.vue?vue&type=script&lang=js"
import style0 from "./SectionRanking.vue?vue&type=style&index=0&id=07e17978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e17978",
  null
  
)

export default component.exports